<template>
  <div id="radio-recliner-featured">
    <div class="rr-main">
      <video class="rr-main-vid" autoplay muted loop>
        <source src="@/assets/video/rr-intro.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
    <div class="section-header">
      <h2>Radio Recliner</h2>
      <h3>
        A pirate radio station run by real Resident DJs at retirement
        <br class="tablet-up-only" />communities across the country, so they can
        stay connected <br class="tablet-up-only" />while they're confined to
        their rooms.
      </h3>
    </div>
    <div class="scroll-info-cont">
      <div class="rr-scroll-cont">
        <video
          class="rr-scroll-vid"
          autoplay
          muted
          loop
          poster="@/assets/images/radio-recliner/radio_recliner_scroll.jpeg"
        >
          <source
            src="@/assets/video/radio_recliner_scroll.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>
      <div class="rr-awards">
        <p>
          <a
            href="https://clios.com/awards/winners?program=clios&amp;search=radio%2Brecliner&amp;year=2020"
            target="_blank"
            rel="noopener"
            >Clio Awards</a
          >
          <span class="tablet-up-only">/ </span><br class="mobile-only" />2
          Silver, 1 Bronze<br />
        </p>
        <p>
          <a
            href="https://vote.webbyawards.com/PublicVoting#/2021/advertising-media-pr/branded-content/health-wellness-pharmaceutical"
            target="_blank"
            rel="noopener"
            >Webby Awards</a
          >
          <span class="tablet-up-only">/ </span
          ><br class="mobile-only" />Nominee &amp; 2 Honorees<br />
        </p>
        <p>
          <a
            href="https://www.commarts.com/project/31898/bridge-senior-living"
            target="_blank"
            rel="noopener"
            >Communication Arts Ad Annual</a
          >
          <span class="tablet-up-only">/ </span
          ><br class="mobile-only" />Digital Advertising<br />
        </p>
        <p>
          <a
            href="http://www.radiomercuryawards.com/2020Winners.cfm"
            target="_blank"
            rel="noopener"
            >Radio Mercury Awards</a
          >
          <span class="tablet-up-only">/ </span><br class="mobile-only" />Best
          Use of Audio<br />
        </p>
        <p>
          <a
            href="https://atlantaadclub.org/wp-content/uploads/2021/03/2021-ADDY-Winner-Book-Reduce-1-1.pdf"
            target="_blank"
            rel="noopener"
            >Atlanta Addys</a
          >
          <span class="tablet-up-only">/ </span><br class="mobile-only" />Best
          in Show, Judge’s Choice, 2 Gold
        </p>
      </div>
    </div>
    <h2 class="in-news">Radio Recliner in the News!</h2>
    <div class="rr-press-vids">
      <div class="kelly-ryan">
        <iframe
          src="https://player.vimeo.com/video/428587908?app_id=122963&amp;api=1&amp;player_id=vimeo_id_3"
          class="rr-news-video"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen=""
          title="Good News of the Day Senior Citizens Are the DJs on Radio Recliner"
          data-ready="true"
          id="vimeo_id_3"
        ></iframe>
      </div>
      <div class="cbs-this-morning">
        <iframe
          src="https://player.vimeo.com/video/445310005?app_id=122963&amp;api=1&amp;player_id=vimeo_id_2"
          class="rr-news-video"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen=""
          title="CBS PART 2 Residents of senior living facilities are turning to internet radio to connect during lockdown"
          data-ready="true"
          id="vimeo_id_2"
        ></iframe>
      </div>
      <div class="rr-case-study">
        <iframe
          src="https://player.vimeo.com/video/562939256"
          class="rr-news-video"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen
          data-ready="true"
        ></iframe>
      </div>
    </div>
    <div class="news-logos">
      <div class="slider">
        <div class="slide-track">
          <div class="slide">
            <!-- CBS This Morning -->
            <a href="https://vimeo.com/418077177" target="_blank">
              <img
                src="@/assets/images/radio-recliner/press-logos/cbs-this-morning.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- Adweek -->
            <a
              href="https://www.adweek.com/brand-marketing/nostalgia-music-and-this-pirate-radio-station-bring-older-adults-together/"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/adweek.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- NPR -->
            <a
              href="https://www.wabe.org/senior-living-residents-host-new-online-radio-station-called-radio-recliner/"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/npr.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- USNews -->
            <a
              href="https://www.usnews.com/news/entertainment/articles/2020-05-11/retirees-isolated-by-virus-become-djs-for-new-radio-hour"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/us-news-world-report.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- AP -->
            <a href="https://bit.ly/2Lkssux" target="_blank">
              <img
                src="@/assets/images/radio-recliner/press-logos/ap.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- CBS News -->
            <a
              href="https://www.wtoc.com/2020/04/30/turn-up-dial-senior-living-facility-residents-take-over-online-radio-show/?outputType=amp"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/cbs-news.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- FOX -->
            <a
              href="https://www.wbrc.com/2020/05/03/tune-turn-it-up-online-radio-station-connects-senior-communities/"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/fox.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- GPB -->
            <a
              href="https://www.gpbnews.org/post/senior-living-residents-dj-online-radio-show-their-recliners"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/gpb.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- AdAge -->
            <a
              href="https://adage.com/article/agency-brief/agency-brief-rga-lays-10-percent-staff-and-holding-companies-post-bleak-earnings/2253911"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/adage.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- WABE -->
            <a
              href="https://www.wabe.org/elderly-couple-radio/"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/WABE_NPR.svg"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- Wash Post -->
            <a
              href="https://www.washingtonpost.com/national/coronavirus-elderly-radio-recliner/2020/06/01/c40c24c4-99ed-11ea-a282-386f56d579e6_story.html"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/washington-post.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- abc News -->
            <a
              href="https://www.abc15.com/news/national/radio-recliner-pirate-radio-station-helps-seniors-deal-with-isolation-loneliness"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/abc-news.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- All Things Considered -->
            <a
              href="https://www.npr.org/2020/06/30/885659569/new-internet-radio-station-helps-seniors-share-their-favorite-music"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/ALL_THINGS_CONSIDERED.svg"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- NBC -->
            <a
              href="https://www.wsmv.com/video/franklin-senior-center-creates-coronavirus-radio/video_d05db95c-f6ec-5676-9a97-e242e92cdac7.html"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/nbc.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- New York Post -->
            <a href="" target="_blank">
              <img
                src="@/assets/images/radio-recliner/press-logos/new-york-post.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- USA Today -->
            <a
              href="https://www.usatoday.com/videos/news/nation/2020/05/11/isolated-retirees-start-radio-hour-amid-virus/651358000/"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/usa-today.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <!-- Start Duplicate Slides -->
          <div class="slide">
            <!-- CBS This Morning -->
            <a href="https://vimeo.com/418077177" target="_blank">
              <img
                src="@/assets/images/radio-recliner/press-logos/cbs-this-morning.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- Adweek -->
            <a
              href="https://www.adweek.com/brand-marketing/nostalgia-music-and-this-pirate-radio-station-bring-older-adults-together/"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/adweek.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- NPR -->
            <a
              href="https://www.wabe.org/senior-living-residents-host-new-online-radio-station-called-radio-recliner/"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/npr.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- USNews -->
            <a
              href="https://www.usnews.com/news/entertainment/articles/2020-05-11/retirees-isolated-by-virus-become-djs-for-new-radio-hour"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/us-news-world-report.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- AP -->
            <a href="https://bit.ly/2Lkssux" target="_blank">
              <img
                src="@/assets/images/radio-recliner/press-logos/ap.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- CBS News -->
            <a
              href="https://www.wtoc.com/2020/04/30/turn-up-dial-senior-living-facility-residents-take-over-online-radio-show/?outputType=amp"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/cbs-news.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- FOX -->
            <a
              href="https://www.wbrc.com/2020/05/03/tune-turn-it-up-online-radio-station-connects-senior-communities/"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/fox.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- GPB -->
            <a
              href="https://www.gpbnews.org/post/senior-living-residents-dj-online-radio-show-their-recliners"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/gpb.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- AdAge -->
            <a
              href="https://adage.com/article/agency-brief/agency-brief-rga-lays-10-percent-staff-and-holding-companies-post-bleak-earnings/2253911"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/adage.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- WABE -->
            <a
              href="https://www.wabe.org/elderly-couple-radio/"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/WABE_NPR.svg"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- Wash Post -->
            <a
              href="https://www.washingtonpost.com/national/coronavirus-elderly-radio-recliner/2020/06/01/c40c24c4-99ed-11ea-a282-386f56d579e6_story.html"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/washington-post.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- abc News -->
            <a
              href="https://www.abc15.com/news/national/radio-recliner-pirate-radio-station-helps-seniors-deal-with-isolation-loneliness"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/abc-news.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- All Things Considered -->
            <a
              href="https://www.npr.org/2020/06/30/885659569/new-internet-radio-station-helps-seniors-share-their-favorite-music"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/ALL_THINGS_CONSIDERED.svg"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- NBC -->
            <a
              href="https://www.wsmv.com/video/franklin-senior-center-creates-coronavirus-radio/video_d05db95c-f6ec-5676-9a97-e242e92cdac7.html"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/nbc.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- New York Post -->
            <a href="" target="_blank">
              <img
                src="@/assets/images/radio-recliner/press-logos/new-york-post.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
          <div class="slide">
            <!-- USA Today -->
            <a
              href="https://www.usatoday.com/videos/news/nation/2020/05/11/isolated-retirees-start-radio-hour-amid-virus/651358000/"
              target="_blank"
            >
              <img
                src="@/assets/images/radio-recliner/press-logos/usa-today.png"
                height="100"
                width="250"
                alt=""
            /></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import "../scss/styles.scss";

#radio-recliner-featured {
  .section-header {
    text-align: center;
    padding: 0 1rem;
    h2 {
      color: #ffc32c;
      margin-top: 3.5rem;
      @include md {
        font-size: 3rem;
      }
    }
    h3 {
      margin-top: 1rem;
      @include mobile-down {
        font-size: 1rem;
      }
    }
  }

  .rr-main-vid {
    width: 100%;
  }

  .rr-scroll-cont {
    text-align: center;
  }
  .rr-scroll-vid {
    width: 320px;
    height: 240px;
    @include md {
      width: 640px;
      height: 480px;
    }
  }

  .scroll-info-cont {
    @include md {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .rr-awards {
      text-align: center;
      padding: 0 1rem 1rem;
      a {
        text-decoration: none;
        color: $mcf-blue;
        font-weight: 600;
        font-family: "Montserrat", sans-serif;
      }
      p {
        @include md {
          margin-bottom: 0.5rem;
        }
      }
      @include md {
        text-align: left;
        padding-left: 1rem;
        margin-right: 2rem;
        a {
          font-size: 1.6rem;
        }
      }
    }
  }
  .rr-press-vids {
    text-align: center;
    max-width: 1600px;
    margin: 0 auto 1rem;
    @include lg {
      display: flex;
      justify-content: space-around;
    }
  }
  .rr-news-video {
    width: 366px;
    height: 200px;
    @include md {
      width: 466px;
      height: 300px;
    }
  }
  .in-news {
    text-align: center;
    margin-bottom: 1rem;
    @include md {
      font-size: 2rem;
    }
  }
  .iframe-container {
    overflow: hidden;
    /* 16:9 aspect ratio */
    padding-top: 56.25%;
    position: relative;
  }
  .iframe-container iframe {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
  }
}
// News Slider
.news-logos {
  align-items: center;
  // background: #e3e3e3;
  display: flex;
  justify-content: center;
  margin: 2rem 0;

  @mixin white-gradient {
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0) 20%
    );
    @include md {
      background: linear-gradient(
        to right,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }

  $animationSpeed: 40s;

  // Animation
  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(calc(-250px * 16));
    }
  }

  // Styling
  .slider {
    background: white;
    height: 100px;
    margin: auto;
    overflow: hidden;
    position: relative;
    width: 100%;

    &::before,
    &::after {
      @include white-gradient;
      content: "";
      height: 120px;
      position: absolute;
      width: 200px;
      z-index: 2;
    }

    &::after {
      right: 0;
      top: 0;
      transform: rotateZ(180deg);
    }

    &::before {
      left: 0;
      top: 0;
    }

    .slide-track {
      animation: scroll $animationSpeed linear infinite;
      display: flex;
      width: calc(250px * 8);
    }

    .slide {
      height: 100px;
      width: 250px;
    }
  }
}
</style>